document.addEventListener('DOMContentLoaded', function () {
  var tacForm = document.querySelector('.js-form--tac') || false;
  if (tacForm !== false) {
    var checkbox = tacForm.querySelector('.js-form--checkbox');
    var submit = tacForm.querySelector('.js-form--submit');
    var toggle = null;
    checkbox.addEventListener('change', function () {
      clearTimeout(toggle);
      if (checkbox.checked) {
        submit.style.display = 'block';
        toggle = setTimeout(function () {
          submit.classList.add('js-active');
          ;
        }, 1);
      } else {
        submit.classList.remove('js-active');
        toggle = setTimeout(function () {
          submit.style.display = 'none';
        }, 300);
      }
    });
  }
});